export default "__VITE_ASSET__DhW8VJwO__"